import { render, staticRenderFns } from "./OnFittingItemArticles.vue?vue&type=template&id=4b7253cb&scoped=true"
import script from "./OnFittingItemArticles.vue?vue&type=script&lang=js"
export * from "./OnFittingItemArticles.vue?vue&type=script&lang=js"
import style0 from "./OnFittingItemArticles.vue?vue&type=style&index=0&id=4b7253cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7253cb",
  null
  
)

export default component.exports